import {Column, Entity, ManyToOne, RelationId} from "typeorm";
import type {Relation} from "typeorm";
import {BaseEntity} from "@/modules/base/entity";
import {Min} from "class-validator";
import {Competition} from ".";
import {Player} from "@/modules/team/entity";
import {CardEnum} from "@/modules/match/enums";

@Entity()
export class Suspension extends BaseEntity {
  @ManyToOne(() => Player)
  player: Relation<Player>;

  @ManyToOne(() => Competition)
  competition: Relation<Competition>;

  @RelationId((suspension: Suspension) => suspension.competition)
  competitionId: number;

  @Column({type: 'varchar', enum: CardEnum})
  card: CardEnum;

  @Column({type: 'integer', unsigned: true})
  @Min(1)
  remainingMatches: number;

  @Column({type: 'integer', unsigned: true})
  @Min(1)
  totalMatches: number;
}
